import { render } from "./upload-test.vue?vue&type=template&id=708d6d44"
import script from "./upload-test.vue?vue&type=script&lang=js"
export * from "./upload-test.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__